// Import Redux Types
import {
  DOWNLOAD_HOME_DATA,
  SUCCESS_DOWNLOAD_HOME_DATA,
  ERROR_DOWNLOAD_HOME_DATA
} from '../types/index'
// Import Services
import { get } from './../services/api'



// Functions
export function downloadHomeDataAction() {
  return async ( dispatch:any ) => {
    dispatch( downloadHomeData() )
    try {
      const response = await get('h0m3d4t4')
			dispatch( successDownloadHomeData( response ) )
    } catch(error) {
      dispatch( errorDownloadHomeData() )
    }
  }
}
const downloadHomeData = () => ({
  type: DOWNLOAD_HOME_DATA
})
const successDownloadHomeData = (data:any) => ({
  type: SUCCESS_DOWNLOAD_HOME_DATA,
  payload: data
})
const errorDownloadHomeData = () => ({
  type: ERROR_DOWNLOAD_HOME_DATA
})
